import { useState, useMemo, useEffect } from "react"
import AdminPanelTabs from "./AP_Tabs"

const TABS = [
  { key: "products", label: "Products" },
  { key: "categories", label: "Categories" },
  { key: "orders", label: "Orders" },
  { key: "users", label: "Users" },
  { key: "signup", label: "Sign Up" },
  { key: "inquiries", label: "Inquiries" },
]

const AdminPanelMain = ({ user }) => {
  /* ----------------------------------
     default tab once (avoid re-render reset)
  ---------------------------------- */
  const defaultTab = useMemo(() => "products", [])
  const [tab, setTab] = useState(defaultTab)
  const [newInquiries, setNewInquiries] = useState(0)

  /* New Contact Us messages, shown as a badge on the Inquiries tab */
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/inquiries?status=new`, { credentials: "include" })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => d && setNewInquiries(d.counts?.new || 0))
      .catch(() => {})
  }, [])

  /* ----------------------------------
     safety (should never happen if RequireAuth)
  ---------------------------------- */
  if (!user) return null
  return (
    <div className="AdminPanelMain d-flex flex-column align-items-center w-100">
      {/* header */}
      <div className="w-100 d-flex justify-content-end px-3 pt-3"></div>

      {/* tabs */}
      <div className="container mb-4">
        <div className="row g-2">
          {TABS.map(({ key, label }) => (
            <div key={key} className="col-sm col-6">
              <button
                type="button"
                onClick={() => setTab(key)}
                className={`btn btn-lg w-100 py-3 fs-5 ${
                  tab === key ? "btn-primary" : "btn-outline-primary"
                }`}
              >
                {label}
                {key === "inquiries" && newInquiries > 0 && (
                  <span className="badge rounded-pill bg-danger ms-2 fs-6 align-middle">
                    {newInquiries}
                    <span className="visually-hidden"> new</span>
                  </span>
                )}
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* content */}
      <div className="w-100">
        <AdminPanelTabs tab={tab} user={user} onInquiryCount={setNewInquiries} />
      </div>
    </div>
  )
}

export default AdminPanelMain
